"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchEventMap = exports.FetchTypeMap = exports.RequestMethod = void 0;
const eventBus_1 = require("../../eventBus");
var RequestMethod;
(function (RequestMethod) {
    RequestMethod["GET"] = "GET";
    RequestMethod["POST"] = "POST";
    RequestMethod["PUT"] = "PUT";
    RequestMethod["PATCH"] = "PATCH";
    RequestMethod["DELETE"] = "DELETE";
})(RequestMethod || (exports.RequestMethod = RequestMethod = {}));
var FetchTypeMap;
(function (FetchTypeMap) {
    FetchTypeMap["FETCH"] = "FETCH";
    FetchTypeMap["FETCH_RESPONSE"] = "FETCH_RESPONSE";
})(FetchTypeMap || (exports.FetchTypeMap = FetchTypeMap = {}));
exports.FetchEventMap = {
    [FetchTypeMap.FETCH]: (eventBus_1.EventConfigurable),
    [FetchTypeMap.FETCH_RESPONSE]: (eventBus_1.EventConfigurable),
};
//# sourceMappingURL=types.js.map